/* DOMNO. pick-a-card popup v3: the game, Klaviyo sign-up, the code, and when it shows. */
(function () {
  'use strict';
  var root = document.getElementById('dc-root');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var CFG = {
    companyId: 'STCDP5',
    listEmail: 'Xbtg9k',
    listSms: 'SdCkKR',
    codeEndpoint: 'https://spin.domno.com/code',
    revision: '2025-01-15',
    delayMs: 5000,
    snoozeDays: 5,
    variant: 'cards_v1',
    source: 'DOMNO cards popup v1',
    smsCountries: ['GB', 'US', 'CA', 'AU', 'NZ', 'IE']
  };

  var qs = new URLSearchParams(location.search);
  var dp = qs.get('dp');
  var DEMO = dp === 'cards';
  var FORCE_LIVE = dp === 'cardslive';
  var reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var state = { step: 'cards', flipped: 0, won: false, email: '', name: '', code: '' };
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // Load the background photo early so it is already there when the popup opens
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var wide = window.matchMedia && matchMedia('(min-width: 640px)').matches;
    var u = root.getAttribute(wide ? 'data-photo-d' : 'data-photo-m');
    if (u) { var im = new Image(); im.src = u; }
  }

  /* ---------- open, close, steps ---------- */
  var lastFocus = null;
  function open(step) {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.remove('is-teaser', 'is-closing', 'is-open');
    $('[data-dc-teaser]').hidden = true;
    goto(step || (state.won ? 'form' : 'cards'), true);
    void root.offsetWidth;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    try { document.documentElement.style.overflow = 'hidden'; } catch (e) {}
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    if (state.step !== 'code') store.set('dc_snooze', String(Date.now() + CFG.snoozeDays * 864e5));
    setTimeout(function () {
      root.classList.remove('is-closing');
      root.hidden = true; // closed means gone (no corner tab)
    }, 340);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function goto(name, instant) {
    $$('.dc-step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; s.classList.remove('is-entering'); });
    var cur = $('.dc-step[data-step="' + name + '"]');
    state.step = name;
    $('.dc-box').scrollTop = 0;
    if (!instant && !reduced) { void cur.offsetWidth; cur.classList.add('is-entering'); }
  }

  /* ---------- the game: every card says 15% off, three turned over is a match ---------- */
  function onCard(e) {
    var c = e.currentTarget;
    if (state.won || c.classList.contains('is-up')) return;
    c.classList.add('is-up');
    state.flipped++;
    buzz(8);
    if (state.flipped === 1) track('Cards Popup Played', {});
    var hint = $('[data-dc-hint]');
    if (state.flipped === 1) hint.textContent = 'One down. Pick another...';
    if (state.flipped === 2) hint.textContent = 'Two of a kind. One more...';
    if (state.flipped >= 3) {
      state.won = true;
      store.sset('dc_won', '1');
      hint.textContent = 'Three of a kind!';
      setTimeout(function () {
        $$('.dc-card').forEach(function (k) { k.classList.add('is-up', 'is-match'); });
        buzz([12, 50, 22]);
      }, 450);
      setTimeout(function () { goto('form'); }, reduced ? 400 : 1900);
    }
  }
  function markWon() {
    state.won = true; state.flipped = 4;
    $$('.dc-card').forEach(function (k) { k.classList.add('is-up', 'is-match'); });
    $('[data-dc-hint]').textContent = 'Three of a kind!';
  }

  /* ---------- network ---------- */
  function kpost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CFG.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': CFG.revision },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }
  function getCode(email, name) {
    if (DEMO) return wait(800).then(function () { return { code: 'LUCK15-DEMO42' }; });
    return withTimeout(fetch(CFG.codeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, first_name: name, kind: 'cards', country: root.getAttribute('data-country') })
    }).then(function (r) { if (!r.ok) throw new Error('code ' + r.status); return r.json(); }), 7000);
  }
  function subscribeEmail(email, name, code) {
    if (DEMO) return Promise.resolve();
    var profile = { data: { type: 'profile', attributes: { email: email, first_name: name, properties: { popup_variant: CFG.variant, coupon: 'discount' } } } };
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source,
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listEmail } } } } };
    return kpost('profiles', profile).catch(function () {}).then(function () {
      return kpost('subscriptions', sub).catch(function () { return kpost('subscriptions', sub); });
    }).then(function () {
      try { if (window.klaviyo && klaviyo.identify) klaviyo.identify({ email: email, first_name: name }); } catch (e) {}
      track('Cards Popup Submitted', { code_shown: !!code, popup_variant: CFG.variant }, email);
    });
  }
  function subscribeSms(phone) {
    if (DEMO) return wait(600);
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source + ' (SMS)',
      profile: { data: { type: 'profile', attributes: { email: state.email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listSms } } } } };
    return kpost('subscriptions', sub).then(function () { track('Cards Popup SMS Entered', {}, state.email); });
  }
  function track(metric, props, email) {
    if (DEMO) return;
    try { if (window.dataLayer) dataLayer.push({ event: 'dc_' + metric.toLowerCase().split(' ').join('_') }); } catch (e) {}
    var em = email || state.email;
    if (!em) return;
    kpost('events', { data: { type: 'event', attributes: { properties: props || {},
      metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: { email: em } } } } } }).catch(function () {});
  }

  /* ---------- forms ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function showErr(el, msg) { el.textContent = msg; el.hidden = !msg; }
  function bad(input, on) {
    var f = input.closest('.dc-field');
    f.classList.toggle('is-bad', on);
    if (on) { f.classList.remove('is-shake'); void f.offsetWidth; f.classList.add('is-shake'); }
  }
  function loading(btn, on) { btn.disabled = on; btn.classList.toggle('is-loading', on); }

  function onEmailSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-dc-err]');
    var nameI = f.elements.first_name, mailI = f.elements.email;
    var name = (nameI.value || '').trim(), email = (mailI.value || '').trim().toLowerCase();
    bad(nameI, !name); bad(mailI, !!name && !EMAIL_RE.test(email));
    if (!name) { nameI.focus(); return showErr(err, 'We need your first name.'); }
    if (!EMAIL_RE.test(email)) { mailI.focus(); return showErr(err, "That email doesn't look right."); }
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    state.name = name; state.email = email;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    getCode(email, name).then(function (d) { if (d && d.existing) state.existing = true; return d && d.code ? d.code : ''; }, function () { return ''; })
      .then(function (code) {
        // Already a customer: no code and no welcome-flow sign-up, just a friendly hello
        if (state.existing) { track('Cards Popup Existing Customer', {}, email); return null; }
        state.code = code; return subscribeEmail(email, name, code).then(function () { return code; });
      })
      .then(function (code) { store.set('dc_done', '1'); if (state.existing) return showExisting(); showCode(code); applyCode(code); })
      .catch(function () {
        loading(btn, false);
        if (state.code) { store.set('dc_done', '1'); showCode(state.code); applyCode(state.code); return; }
        showErr(err, "Couldn't sign you up just then. Mind trying again?");
      });
  }
  function showExisting() {
    root.classList.add('is-existing');
    $('[data-dc-hello]').textContent = state.name ? 'Hey ' + state.name + ', good to see you' : 'Good to see you';
    $('[data-dc-hascode]').hidden = true;
    var nc = $('[data-dc-nocode]'); nc.hidden = false;
    var p = nc.querySelector('p'); if (p) p.textContent = "Looks like you’re already part of the DOMNO. family, so this one’s for new faces. Good to see you back!";
    var big = root.querySelector('.dc-big'); if (big) big.style.display = 'none';
    $('[data-dc-sms]').hidden = true;
    goto('code');
  }

  function applyCode(code) {
    if (!code) return;
    var done = function () { $('[data-dc-applied]').hidden = false; };
    if (DEMO) return setTimeout(done, 900);
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(function (r) { if (r.ok) done(); }, function () {});
  }
  function showCode(code) {
    $('[data-dc-hello]').textContent = state.name ? state.name + ", here's your 15% off" : "Here's your 15% off";
    $('[data-dc-hascode]').hidden = !code;
    $('[data-dc-nocode]').hidden = !!code;
    if (code) $('[data-dc-codetext]').textContent = code;
    var country = root.getAttribute('data-country');
    $('[data-dc-sms]').hidden = !(CFG.smsCountries.indexOf(country) > -1 || DEMO);
    var cc = { GB: '44', US: '1', CA: '1', AU: '61', NZ: '64', IE: '353' }[country];
    if (cc) { var sel = $('#dc-cc'); for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === cc) { sel.selectedIndex = i; break; } }
    goto('code');
    buzz([10, 40, 18]);
  }
  function onCopy() {
    var t = $('[data-dc-copy]'), code = $('[data-dc-codetext]').textContent, label = $('[data-dc-copied]');
    var done = function () {
      t.classList.add('is-copied'); label.textContent = 'Copied';
      buzz(8);
      setTimeout(function () { t.classList.remove('is-copied'); label.textContent = 'Copy'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done();
    }
  }
  function onSmsSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-dc-smserr]'), cc = f.elements.cc.value;
    var digits = (f.elements.phone.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
    if (digits.indexOf(cc) === 0 && digits.length > 10) digits = digits.slice(cc.length);
    var ok = digits.length >= 6 && digits.length <= 13;
    bad(f.elements.phone, !ok);
    if (!ok) return showErr(err, "That number doesn't look right.");
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    subscribeSms('+' + cc + digits).then(function () {
      $('[data-dc-sms]').hidden = true;
      $('[data-dc-entered]').hidden = false;
    }, function () {
      loading(btn, false);
      showErr(err, "Couldn't add your number just then. Mind trying again?");
    });
  }

  /* ---------- wiring ---------- */
  $$('.dc-card').forEach(function (c) { c.addEventListener('click', onCard); });
  $$('[data-dc-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
  $('[data-dc-form]').addEventListener('submit', onEmailSubmit);
  $('[data-dc-smsform]').addEventListener('submit', onSmsSubmit);
  $('[data-dc-copy]').addEventListener('click', onCopy);
  $('[data-dc-teaser]').addEventListener('click', function () { open(); });
  $('[data-dc-shop]').addEventListener('click', function () { document.documentElement.style.overflow = ''; });
  $$('.dc-field input').forEach(function (i) { i.addEventListener('input', function () { i.closest('.dc-field').classList.remove('is-bad'); }); });
  window.__dc = { root: root, CFG: CFG, state: state, open: open, close: close, goto: goto };

  /* ---------- demo screens (?dp=cards&dc_step=) ---------- */
  function demoJump(s) {
    if (s === 'form') { markWon(); open('form'); return; }
    if (s === 'code' || s === 'sent' || s === 'done') {
      markWon(); state.name = 'Sam'; open('form');
      showCode(s === 'sent' ? '' : 'LUCK15-DEMO42');
      if (s !== 'sent') $('[data-dc-applied]').hidden = false;
      if (s === 'done') { $('[data-dc-sms]').hidden = true; $('[data-dc-entered]').hidden = false; }
      return;
    }
    open('cards');
  }

  /* ---------- should it show? ---------- */
  function blocked() {
    if (root.getAttribute('data-customer') === 'true') return true;
    if (store.get('dc_done') || store.get('ds_done')) return true;
    var snooze = parseInt(store.get('dc_snooze') || '0', 10);
    if (snooze && Date.now() < snooze) return true;
    if (/^\/(cart|checkout|account|challenge)/.test(location.pathname)) return true;
    if (qs.get('_kx') || qs.get('utm_medium') === 'email' || qs.get('utm_medium') === 'sms') return true;
    return false;
  }
  function identified() {
    try {
      if (window.klaviyo && typeof klaviyo.isIdentified === 'function') {
        return withTimeout(Promise.resolve(klaviyo.isIdentified()), 1500).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }
  function showTeaser() {
    if (store.sget('dc_won')) markWon();
    root.hidden = false; root.classList.add('is-teaser');
    var t = $('[data-dc-teaser]'); t.querySelector('b').textContent = state.won ? 'Your 15% off' : 'Try your luck'; t.hidden = false;
  }

  if (DEMO || FORCE_LIVE) warm();
  if (DEMO) { setTimeout(function () { demoJump(qs.get('dc_step') || 'cards'); }, 400); return; }
  if (FORCE_LIVE) { setTimeout(function () { open('cards'); }, 400); return; }
  // Intelligems sets window.DOMNO_POPUP as it loads. Usually ~2-3s, but on slow phones it can be later,
  // so keep checking every half second for up to 20s. Opens 5s after the page loads, or as soon as Intelligems is ready if that's later.
  (function whenReady(fn) {
    var t0 = Date.now();
    (function check() {
      if (window.DOMNO_POPUP) return fn();
      if (Date.now() - t0 < 20000) setTimeout(check, 500);
    })();
  })(function () {
  if (window.DOMNO_POPUP === 'cards' && !blocked()) warm();
  setTimeout(function () {
    if (window.DOMNO_POPUP !== 'cards') return;
    if (store.get('dc_done') || store.get('ds_done')) return;
    if (blocked()) return;
    identified().then(function (yes) { if (!yes) open('cards'); });
  }, Math.max(0, CFG.delayMs - (window.performance ? performance.now() : 0)));
  });
})();